import { render, staticRenderFns } from "./receipt-items.vue?vue&type=template&id=2d7d486b&"
import script from "./receipt-items.vue?vue&type=script&lang=js&"
export * from "./receipt-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7d486b')) {
      api.createRecord('2d7d486b', component.options)
    } else {
      api.reload('2d7d486b', component.options)
    }
    module.hot.accept("./receipt-items.vue?vue&type=template&id=2d7d486b&", function () {
      api.rerender('2d7d486b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/receipt-items.vue"
export default component.exports